import { PureComponent, PropsWithChildren } from "react";

import { FormatUtils } from "@dndbeyond/character-rules-engine/es";

interface Props extends PropsWithChildren {
  propertyKey: string;
  className: string;
}
export default class DescriptionPaneEditor extends PureComponent<Props> {
  render() {
    const { propertyKey, className } = this.props;

    let classNames: Array<string> = [
      "ct-description-pane__editor",
      `ct-description-pane__editor--${FormatUtils.slugify(propertyKey)}`,
      className,
    ];

    return <div className={classNames.join(" ")}>{this.props.children}</div>;
  }
}
